import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

export default function AlertDialog({ remove, machine,handleRemoveAgree,handleDialogDisagree }) {
  return (
    <div>
      <Dialog
        open={remove}
        onClose={handleDialogDisagree}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Are you sure to remove days to fix from 
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
          {[machine.MachineCode]} {[machine.Name]}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogDisagree}>Disagree</Button>
          <Button onClick={handleRemoveAgree} autoFocus>
            Agree
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
